// query-keys/job-keys.js
import { queryClient } from "utils/react-query";

const collection = "billables";

export const billableKeys = {
  // Base keys
  all: () => [collection],
  details: () => [...billableKeys.all(), "detail"],
  meta: (id) => [...billableKeys.details(), "meta",id],
  detail: (id) => [...billableKeys.details(), id],
  list: () => [collection, "list"],
  activities: (id) => [...billableKeys.detail(id), "activities"],

  // Status-specific queries
  byStatus: (status) => [...billableKeys.all(), "status", status],

  // Project-related billable queries
  byProject: (projectId) => [...billableKeys.all(), "project", projectId],

  // Milestone-related queries (if billables have milestones)
  milestones: (jobId) => [...billableKeys.detail(jobId), "milestones"],
  milestoneCount: (jobId) => [...billableKeys.detail(jobId), "milestone-count"],

  // Search/filter queries
  search: (query) => [...billableKeys.all(), "search", query],

  // Dashboard/stats queries
  stats: () => [...billableKeys.all(), "stats"],
  recent: () => [...billableKeys.all(), "recent"],
};

// Invalidate all queries related to billables (optionally filtered by a predicate)
export function invalidateBillableQueries(predicate) {
  queryClient.invalidateQueries({
    predicate: predicate || (({ queryKey }) => queryKey[0] === collection),
  });
}

// Invalidate all billable queries (no filter)
export function invalidateAllBillableQueries() {
  queryClient.invalidateQueries({
    predicate: ({ queryKey }) => queryKey[0] === collection,
  });
}
